/**
 * „Termin na przyjęcie zamówienia (dni)” umowy ramowej (FrameworkAgreement.acceptance_deadline_days).
 * Po tylu dniach kalendarzowych od wysłania nieprzyjęte zamówienie trafia do dyrekcji jako
 * długo oczekujące — nie jest anulowane samo (backend: apps.orders.acceptance_deadline).
 * Puste = domyślne 5 dni. Wspólne dla
 * „Nowa umowa ramowa” i „Edytuj umowę ramową”.
 */

export const DEFAULT_ACCEPTANCE_DEADLINE_DAYS = 5;

/** Komunikat błędu albo null — puste pole jest poprawne (termin domyślny). */
export function acceptanceDeadlineDaysError(value: string): string | null {
  const v = value.trim();
  if (!v) return null;
  const n = Number(v);
  if (!Number.isInteger(n) || n < 1 || n > 365) return "Podaj liczbę dni od 1 do 365 (albo zostaw puste — 5 dni)";
  return null;
}

/** „7 dni” / „5 dni (domyślnie)” — do podglądu umowy. */
export function acceptanceDeadlineDaysLabel(days: number | null | undefined): string {
  if (days == null) return `${DEFAULT_ACCEPTANCE_DEADLINE_DAYS} dni (domyślnie)`;
  return `${days} ${days === 1 ? "dzień" : "dni"}`;
}

export function AcceptanceDeadlineDaysField({
  value,
  onChange,
  error,
}: {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}) {
  return (
    <div>
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300 block mb-1" htmlFor="acceptance-deadline-days">
        Termin na przyjęcie zamówienia (dni)
      </label>
      <input
        id="acceptance-deadline-days"
        type="number"
        min="1"
        max="365"
        step="1"
        placeholder={`${DEFAULT_ACCEPTANCE_DEADLINE_DAYS} (domyślnie)`}
        className={`block w-40 rounded-md border px-3 py-2 text-sm ${error ? "border-red-400" : "border-gray-300"}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <p className="text-xs text-red-600 mt-0.5">{error}</p>}
      <p className="text-xs text-gray-400 mt-0.5">
        Dni kalendarzowe od wysłania zamówienia. Nieprzyjęte w tym terminie trafi do dyrekcji jako
        długo oczekujące (zgłaszający dostaje monit przed terminem). Puste = {DEFAULT_ACCEPTANCE_DEADLINE_DAYS} dni.
        Nie dotyczy zleceń przyjmowanych automatycznie.
      </p>
    </div>
  );
}
